<ng-template #blockTemplate>
  <div class="d-flex justify-content-center align-items-center block-ui-template">
    <div class="spinner-border" role="status">
      <span class="sr-only">...</span>
    </div>
  </div>
</ng-template>

<ng-template #userItemTemplate let-item="item" let-id="id">
  <div
    class="mt-auto mb-auto truncate-text"
    [ngbTooltip]="item"
    showTooltipIfTruncated
    container="body">
    <ca-clickable-link
      [withoutDiv]="true"
      [innerHtml]="item"
      (linkClicked)="openAgentSummary(id)"
      title="{{ 'CoachingAndTraining::CoachingDashboard:GiveFeedback' | abpLocalization }}"></ca-clickable-link>
  </div>
</ng-template>

<div *blockUI="'conversation-table-block'; template: blockTemplate">
  <table
    mat-table
    matSort
    (matSortChange)="sortData($event)"
    [matSortDirection]="sortDirection$ | async"
    [matSortActive]="sortField$ | async"
    [matSortDisableClear]="true"
    [dataSource]="dataSource"
    aria-describedby="conversation-table">
    <ng-container *ngFor="let gridColumn of gridColumns">
      <ng-template #columnHeaderTooltipTemplate>
        <div [ngClass]="gridColumn.tooltip ? 'fw-bold' : ''">{{ gridColumn.header }}</div>
        <div *ngIf="gridColumn.tooltip">{{ gridColumn.tooltip }}</div>
      </ng-template>
      <ng-container
        *ngIf="
          gridColumn.columnName !== 'conversationId' &&
          gridColumn.columnName !== 'icons' &&
          gridColumn.columnName !== 'userName' &&
          gridColumn.columnName !== 'relatedGroupId' &&
          gridColumn.columnName !== 'departmentName'
        "
        matColumnDef="{{ gridColumn.columnName }}">
        <ng-container *ngIf="gridColumn.sortable === true">
          <th
            mat-header-cell
            [mat-sort-header]="gridColumn.sorterFieldName"
            *matHeaderCellDef
            container="body"
            [ngbTooltip]="columnHeaderTooltipTemplate"
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            scope="col">
            <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
              {{ gridColumn.hideHeader ? '' : gridColumn.header }}
            </span>

            <ca-column-resizer
              [gridId]="gridId"
              [columnId]="gridColumn.columnName"></ca-column-resizer>
          </th>
        </ng-container>
        <ng-container *ngIf="gridColumn.sortable !== true">
          <th
            mat-header-cell
            *matHeaderCellDef
            [ngbTooltip]="columnHeaderTooltipTemplate"
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            container="body"
            scope="col">
            <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
              {{ gridColumn.hideHeader ? '' : gridColumn.header }}
            </span>
            <ca-column-resizer
              [gridId]="gridId"
              [columnId]="gridColumn.columnName"></ca-column-resizer>
          </th>
        </ng-container>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let conversation"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          [ngClass]="gridColumn.cellClass"
          class="truncate-text selectable-cell"
          container="body">
          <div
            [cdkCopyToClipboard]="conversation | objectparser: gridColumn"
            (click)="copyToClipboard()"
            class="truncate-text conversation-copy-to-clipboard"
            [ngbTooltip]="conversation | objectparser: gridColumn"
            showTooltipIfTruncated
            title="{{ '::CopytoClipboard' | abpLocalization }}">
            {{ conversation | objectparser: gridColumn }}
          </div>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'departmentName'"
        matColumnDef="{{ gridColumn.columnName }}">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngbTooltip]="columnHeaderTooltipTemplate"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          [ngClass]="gridColumn.headerClass"
          container="body"
          scope="col">
          <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
            {{ gridColumn.hideHeader ? '' : gridColumn.header }}
          </span>
          <ca-column-resizer
            [gridId]="gridId"
            [columnId]="gridColumn.columnName"></ca-column-resizer>
        </th>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let conversation"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          class="selectable-cell department-cell"
          container="body">
          <div
            [cdkCopyToClipboard]="
              conversation.departmentHierarchyName || conversation.departmentName
            "
            (click)="copyToClipboard()"
            class="truncate-text conversation-copy-to-clipboard department-hierarchy-cell"
            title="{{ '::CopytoClipboard' | abpLocalization }}"
            #tooltip="ngbTooltip"
            [ngbTooltip]="departmentHierarchyTemplate"
            container="body"
            triggers="manual"
            (mouseenter)="showDepartmentTooltip(conversation, tooltip)"
            (mouseleave)="tooltip.close()">
            {{ conversation.departmentHierarchyName || conversation.departmentName }}
          </div>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'conversationId'"
        matColumnDef="{{ gridColumn.columnName }}"
        [sticky]="gridColumn.sticky">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          scope="col"
          [ngClass]="gridColumn.headerClass">
          <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
            {{ gridColumn.hideHeader ? '' : gridColumn.header }}
          </span>
          <ca-column-resizer
            [gridId]="gridId"
            [columnId]="gridColumn.columnName"></ca-column-resizer>
        </th>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          class="selectable-cell"
          *matCellDef="let conversation">
          <div class="d-flex">
            <span
              *ngIf="canAccessConversationRecordings"
              ngbTooltip="{{ 'Conversation::AudioUnavailableUntilProcessed' | abpLocalization }}"
              [disableTooltip]="!getPlayButtonDisability(conversation)"
              container="body">
              <button
                *ngIf="
                  conversation.typeId != conversationType.chat &&
                  conversation.typeId != conversationType.email &&
                  (playingConversationId != conversation.id ||
                    (playingConversationId == conversation.id && !audioPlaying && !audioLoading))
                "
                type="button"
                class="btn btn-sm ca-btn ca-btn-outline ca-btn-player-controller toolbar-button"
                (click)="onPlayButtonClick(conversation)"
                [disabled]="getPlayButtonDisability(conversation)">
                <span class="fa-stack fa-1x original">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fas fa-play fa-stack-1x"></i>
                </span>
                <span class="fa-stack fa-1x hover">
                  <i class="fas fa-circle fa-stack-2x outer"></i>
                  <i class="fas fa-play fa-stack-1x inner"></i>
                </span>
              </button>
              <button
                *ngIf="
                  conversation.typeId != conversationType.chat &&
                  conversation.typeId != conversationType.email &&
                  playingConversationId == conversation.id &&
                  audioPlaying
                "
                type="button"
                class="btn btn-sm ca-btn ca-btn-outline ca-btn-player-controller toolbar-button"
                (click)="onPauseButtonClick()">
                <span class="fa-stack fa-1x original">
                  <i class="far fa-circle fa-stack-2x"></i>
                  <i class="fas fa-pause fa-stack-1x"></i>
                </span>
                <span class="fa-stack fa-1x hover">
                  <i class="fas fa-circle fa-stack-2x outer"></i>
                  <i class="fas fa-pause fa-stack-1x inner"></i>
                </span>
              </button>
              <button
                *ngIf="
                  conversation.typeId != conversationType.chat &&
                  conversation.typeId != conversationType.email &&
                  playingConversationId == conversation.id &&
                  audioLoading
                "
                type="button"
                class="btn btn-sm ca-btn ca-btn-outline ca-btn-player-controller toolbar-button">
                <span class="fa-stack fa-1x">
                  <i class="fa-duotone fa-spinner-third fa-spin fa-2x"></i>
                </span>
              </button>
            </span>
            <ca-clickable-link
              class="d-flex align-items-center w-100"
              [cls]="'truncate w-100'"
              [innerHtml]="conversation | objectparser: gridColumn"
              [targetLink]="['/conversation', 'v2', conversation.id]"
              [params]="getQueryParams()"
              [state]="getState()"></ca-clickable-link>
          </div>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'userName'"
        matColumnDef="{{ gridColumn.columnName }}"
        [sticky]="gridColumn.sticky">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngbTooltip]="columnHeaderTooltipTemplate"
          [disableTooltip]="gridColumn.hideHeader"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          container="body"
          scope="col"
          [ngClass]="gridColumn.headerClass">
          <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
            {{ gridColumn.hideHeader ? '' : gridColumn.header }}
          </span>
          <ca-column-resizer
            [gridId]="gridId"
            [columnId]="gridColumn.columnName"></ca-column-resizer>
        </th>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let conversation"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          container="body">
          <ca-user-identity
            [id]="conversation.userId"
            [name]="conversation.userName"
            [surname]="conversation.userSurname"
            [item]="conversation.userName"
            [itemTemplate]="userItemTemplate"></ca-user-identity>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'icons'"
        matColumnDef="{{ gridColumn.columnName }}">
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.minWidth || gridColumn.width"
          [style.maxWidth]="gridColumn.maxWidth"
          scope="col">
          <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
            {{ gridColumn.hideHeader ? '' : gridColumn.header }}
          </span>
          <ca-column-resizer
            [gridId]="gridId"
            [columnId]="gridColumn.columnName"></ca-column-resizer>
        </th>
        <td
          mat-cell
          *matCellDef="let conversation"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width">
          <ca-conversation-icon-container
            [conversation]="conversation"
            [showConversationType]="(activeList$ | async) === listType.mixed"
            [sentimentFeatureEnabled]="sentimentFeatureEnabled"></ca-conversation-icon-container>
        </td>
      </ng-container>
      <ng-container
        *ngIf="gridColumn.columnName === 'relatedGroupId'"
        matColumnDef="{{ gridColumn.columnName }}">
        <ng-container *ngIf="gridColumn.sortable === true">
          <th
            mat-header-cell
            [mat-sort-header]="gridColumn.sorterFieldName"
            *matHeaderCellDef
            container="body"
            [ngbTooltip]="columnHeaderTooltipTemplate"
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            scope="col">
            <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
              {{ gridColumn.hideHeader ? '' : gridColumn.header }}
            </span>
            <ca-column-resizer
              [gridId]="gridId"
              [columnId]="gridColumn.columnName"></ca-column-resizer>
          </th>
        </ng-container>
        <ng-container *ngIf="gridColumn.sortable !== true">
          <th
            mat-header-cell
            *matHeaderCellDef
            [ngbTooltip]="columnHeaderTooltipTemplate"
            [style.width]="gridColumn.width"
            [style.minWidth]="gridColumn.width"
            [style.maxWidth]="gridColumn.width"
            [ngClass]="gridColumn.headerClass"
            container="body"
            scope="col">
            <span [style.maxWidth]="reSizeColumn(gridColumn.width)" class="ellipsis">
              {{ gridColumn.hideHeader ? '' : gridColumn.header }}
            </span>
            <ca-column-resizer
              [gridId]="gridId"
              [columnId]="gridColumn.columnName"></ca-column-resizer>
          </th>
        </ng-container>
        <td
          mat-cell
          [ngClass]="gridColumn.cellClass"
          *matCellDef="let conversation"
          [style.width]="gridColumn.width"
          [style.minWidth]="gridColumn.width"
          [style.maxWidth]="gridColumn.width"
          [ngClass]="gridColumn.cellClass"
          class="truncate-text selectable-cell">
          <ca-clickable-link
            [cls]="'truncate w-100'"
            [innerHtml]="conversation | objectparser: gridColumn"
            (linkClicked)="onRelatedGroupIdClick(conversation.relatedGroupId, conversation.typeId)"
            [showTooltipIfTruncated]="true"></ca-clickable-link>
        </td>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="replyTimeColumnVisible" matColumnDef="replyTime">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="header-align-right"
        scope="col">
        <span class="ellipsis">{{ 'Conversation::ReplyTime' | abpLocalization }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let conversation"
        class="cell-align-right truncate-text selectable-cell">
        {{ getReplyTimeDisplay(conversation) }}
      </td>
    </ng-container>
    <!-- Info column -->
    <ng-container matColumnDef="info">
      <td
        class="pl-0 text-start"
        mat-footer-cell
        *matFooterCellDef
        [attr.colspan]="displayedColumns.length">
        <span>
          <mat-paginator
            (page)="pageChanged($event)"
            [pageIndex]="currentPage"
            [length]="totalCount"
            [pageSize]="pageSize"
            [ngClass]="{ 'disable-last': isInfinity(totalCount) }"
            class="paginator d-flex justify-content-start"
            hidePageSize
            showFirstLastButtons></mat-paginator>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      [ngClass]="
        'conversation-row-' +
        myRowData.id +
        ((playingConversationId >= 0 && myRowData.id === playingConversationId) ||
        (playingConversationId < 0 && myRowData.id === lastActiveConversationId)
          ? ' selected'
          : '')
      "
      (dblclick)="openFullscreen(myRowData.id)"
      *matRowDef="let myRowData; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="['info']; sticky: true"></tr>
    <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
      <td class="mat-cell" [colSpan]="displayedColumns.length">
        {{ 'CA::NoDataFound' | abpLocalization }}
      </td>
    </tr>
  </table>
</div>

<ng-template
  #departmentHierarchyTemplate
  let-departmentId="departmentId"
  let-departmentName="departmentName">
  <div
    *ngIf="isDepartmentHierarchyLoading; else loadedBlock"
    class="d-flex justify-content-center p-2">
    <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <ng-template #loadedBlock>
    <ng-container *ngIf="departmentHierarchyMap.get(departmentId) as value; else errorBlock">
      <div class="dept-tree-content">
        <div
          *ngFor="let part of value.split('\\'); let last = last"
          class="dept-tree-item"
          [class.is-last]="last">
          <span class="conn"></span>
          <span class="node-icon"><i class="far fa-building"></i></span>
          <span class="label">{{ part }}</span>
        </div>
      </div>
    </ng-container>
    <ng-template #errorBlock>
      <div class="dept-tree-content">
        <div class="dept-tree-item root is-last">
          <span class="node-icon" aria-hidden="true"><i class="far fa-building"></i></span>
          <span class="label">{{ departmentName }}</span>
        </div>
        <div class="text-danger small mt-1">
          {{ 'Department::DepartmentPathNotFound' | abpLocalization }}
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-template>
